import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useWindowStore } from '~/store/window';

export function useWindowTracking() {
  const windowStore = useWindowStore();
  const { width, height } = useWindowSize();

  const windowSizes = computed(() => windowStore.windowSizes);

  const windowWidth = computed({
    get: () => windowStore.windowWidth,
    set: (value) => windowStore.setWindowWidth(value),
  });

  const windowHeight = computed({
    get: () => windowStore.windowHeight,
    set: (value) => windowStore.setWindowHeight(value),
  });

  // mounted для того, чтобы не сломать гидратацию
  onMounted(() => {
    windowWidth.value = width.value;
    windowHeight.value = height.value;
  });

  watch([width, height], ([newWidth, newHeight]) => {
    windowWidth.value = newWidth;
    windowHeight.value = newHeight;
  });

  return {
    windowSizes,
    windowWidth,
    windowHeight,
  };
}
